import React from "react";
import { Auth } from "redux-server-connection";
import { NavLink } from "react-router-dom";
import RankedUser from "./RankedUser";

import "./styles.css";

function getFilteredList(props, loggedUser) {
  const showVendor = (props.location.pathname === "/ranking/supervisor" ? true : false);
  
  var vendor = loggedUser.vendor;
  
  var filteredList = [];
  var position = 0;
  var rank = 0;
  var lastValue = 0;
  for (var i = 0; i < props.users.length; i++) {
    var user = props.users[i];
    // Siempre muestra vendedores
    if (user.type === 2) {
      if (showVendor === false || 
          (user.vendor && user.vendor === vendor)) {
        position++;
        if (lastValue !== user.points) {
          rank = position;
          lastValue = user.points;
        }
        filteredList.push({"index": i, "position": position, "rank": rank});
      }
    }
  }
  return filteredList;
}

const Render = (props, context) => {
  const loggedUser = Auth.getUser();
  var filteredList = getFilteredList(props, loggedUser);
  
  return (
    <section className="ranking int pbxl">
      <div className="container">
      <h1 className="avenirBK violet horizontalCenter titleSize">Ranking</h1>
        <ul className="tabs horizontal clearfix horizontalCenter horizontalCenterFlex">
          <li
          >
            <NavLink to="/ranking" className={props.location.pathname === "/ranking" ? "current" : ""}>
              General
            </NavLink>
          </li>
          <li
          >
            <NavLink to="/ranking/supervisor" className={props.location.pathname === "/ranking/supervisor" ? "current" : ""}>
              {loggedUser.vendor}
            </NavLink>
          </li>
        </ul>
        <ul className="rankingUl boxOdd horizontal clearfix mha">
          {filteredList.map(item => (
            <RankedUser
              key={item.position}
              user={props.users[item.index]}
              position={item.position} 
              rank={item.rank}
            />
          ))}
        </ul>
      </div>
    </section>
  );
};

Render.contextTypes = {};

export default Render;



// WEBPACK FOOTER //
// ./src/pages/Ranking/Render.js